import React from "react";
import { UserPlus } from "lucide-react";

export default function FriendRequestList({
  mobile = false,
  requests,
  usersMap,
  friendRequestNotificationsByUserId,
  getAvatarSrc,
  renderTimestamp,
  onAccept,
  onDecline,
  t,
}) {
  const renderMobileFriendRequest = (id) => {
    const user = usersMap[id];
    const requestNotification = friendRequestNotificationsByUserId[id];
    if (!user) return null;

    return (
      <article key={id} className="notif-mobile-request">
        <img src={getAvatarSrc(user)} alt={t("profile_picture")} />
        <div className="notif-mobile-request__body">
          <strong>{user.username}</strong>
          {renderTimestamp(requestNotification?.createdAt)}
        </div>
        <div className="notif-mobile-request__actions">
          <button className="accept-btn" onClick={() => onAccept(id)}>
            {t("accept")}
          </button>
          <button className="decline-btn" onClick={() => onDecline(id)}>
            {t("decline")}
          </button>
        </div>
      </article>
    );
  };

  if (mobile) {
    return (
      <section className="notif-mobile-card notif-mobile-card--requests">
        <div className="notif-mobile-card__header">
          <div>
            <p>{t("notifications_friend_requests")}</p>
            <h3>{t("friend_requests")}</h3>
          </div>
          <span>{requests.length}</span>
        </div>

        {requests.length === 0 ? (
          <div className="notif-mobile-empty">
            <span className="notif-mobile-empty__icon" aria-hidden="true">
              <UserPlus size={28} strokeWidth={2.15} />
            </span>
            <strong>{t("notifications_no_friend_requests")}</strong>
            <p>{t("notifications_no_friend_requests_helper")}</p>
          </div>
        ) : (
          <div className="notif-mobile-request-list">
            {requests.map(renderMobileFriendRequest)}
          </div>
        )}
      </section>
    );
  }

  return (
    <>
      <h4>{t("friend_requests")}</h4>

      {requests.length === 0 && (
        <p className="notif-empty">{t("no_friend_requests")}</p>
      )}

      {requests.map((id) => {
        const user = usersMap[id];
        const requestNotification = friendRequestNotificationsByUserId[id];
        if (!user) return null;

        return (
          <div key={id} className="notif-item">
            <img src={getAvatarSrc(user)} alt={t("profile_picture")} />

            <div className="notif-main">
              <span>{user.username}</span>
              {renderTimestamp(requestNotification?.createdAt)}
            </div>

            <div className="notif-actions">
              <button className="accept-btn" onClick={() => onAccept(id)}>
                {t("accept")}
              </button>
              <button className="decline-btn" onClick={() => onDecline(id)}>
                {t("decline")}
              </button>
            </div>
          </div>
        );
      })}
    </>
  );
}
